<template>
  <div class="wrap">
    <!-- browser-suggestion -->
    <browser-suggestion></browser-suggestion>
    <!-- browser-suggestion -->

    <div class="wrapper">
      <!-- curr-banner -->
      <banners class="curr-banner"></banners>
      <!-- /curr-banner -->

      <!-- 标题 -->
      <div class="page-title">
        <div class="title">
          <a>内部招聘</a>
        </div>
      </div>
      <!-- 标题 -->

      <!-- 搜索 -->
      <div class="search-container">
        <el-form
          :model="SearchForm"
          class="search-form"
          :inline="true"
          label-width="80px"
          ref="SearchForm"
        >
          <el-row>
            <!-- 单位模糊-->
            <el-col :span="6" :xs="24">
              <el-form-item class="search-item" prop="dwmh" label="单位">
                <el-input
                  v-model="SearchForm.dwmh"
                  placeholder="单位"
                  clearable
                  size="mini"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="6" :xs="24">
              <el-form-item class="search-item" prop="gw" label="招聘岗位">
                <el-input
                  v-model="SearchForm.gw"
                  placeholder="招聘岗位"
                  clearable
                  size="mini"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" :xs="24">
              <el-form-item class="search-item" prop="gzdd" label="工作地点">
                <el-input
                  v-model="SearchForm.gzdd"
                  placeholder="工作地点"
                  clearable
                  size="mini"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" :xs="24">
              <el-form-item class="search-item" prop="xl" label="学历要求">
                <el-select
                  v-model="SearchForm.xl"
                  placeholder="学历要求"
                  clearable
                  size="mini"
                >
                  <el-option
                    v-for="(item, index) in commoneduList"
                    :label="item.name"
                    :value="item.oid"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <!-- 高级搜索区域 -->
            <!-- <el-col :span="6" :xs="24" v-show="expandMore" >
                <el-form-item class="search-item" label="学历要求">
                  <el-select
                    v-model="Data.xl"
                    placeholder="学历要求"
                    clearable
                    size="mini"
                  >
                    <el-option
                      v-for="(item, index) in commoneduList"
                      :label="item.name"
                      :value="item.oid"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->
            <!-- 高级搜索区域 -->

            <el-col
              :span="14"
              :offset="expandMore ? 18 : 0"
              :xs="{ span: 24, offset: 0 }"
            >
              <!-- 查询操作栏 -->
              <el-form-item class="search-item search-opts">
                <el-button
                  type="primary"
                  size="mini"
                  @click="searchFromAction()"
                  >查询</el-button
                >
                <el-button type="info" size="mini" @click="searchFromReset()"
                  >重置</el-button
                >
                <el-button
                  type="text"
                  size="mini"
                  v-show="showExpandMore"
                  :icon="expandMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
                  @click="expandMore = !expandMore"
                  >{{ expandMore ? "收起" : "展开" }}</el-button
                >
              </el-form-item>
              <!-- /查询操作栏 -->
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 搜索 -->

      <!-- 列表 -->
      <div class="search-list">
        <div class="corp-tree">
          <el-tree
            :data="orgsTree"
            :props="orgsTreePrps"
            :default-expand-all="true"
            :indent="12"
            @node-click="handleNodeClick"
            node-key="oid"
            :current-node-key="SearchForm.dw"
            ref="corp-tree"
          ></el-tree>
        </div>
        <div class="right-content">
          <div class="campus">
            <div v-if="globalPageParam.total > 0">
              <div
                class="campus-cont"
                v-for="(item, index) in currentPageData"
                :key="index"
                @click="setSelectDataToDetail(item.oid, item.zpgw, item.zpdw)"
              >
                <div class="apply-btn">
                  <el-button
                    type="primary"
                    @click.stop.prevent="
                      applyJob(item.oid, item.zpgw, item.zpdw, item.zpxs)
                    "
                    size="mini"
                    >申请</el-button
                  >
                </div>

                <div class="title">
                  <span>{{ item.zpgw }}</span>
                </div>
                <div class="corp">{{ item.zpdw }}</div>
                <div class="desc clearfix">
                  <div class="tip">
                    {{ item.gzdd }} 招聘人数：{{ item.zprs }}
                  </div>
                  <div class="date">
                    <!-- <i class="el-icon-timer" ></i> -->
                    <span class="icon-title">报名截止日期</span>
                    <span>：</span>
                    <span>{{ item.jzrq }}</span>
                  </div>
                </div>

                <div class="foot">
                  <span>{{ item.xl }}</span> |
                  <span>{{ item.zy }}</span>
                </div>
              </div>
            </div>
            <div class="no-jobs-list" v-else>没有查询到数据</div>
          </div>
        </div>
      </div>

      <!-- 列表 -->

      <!-- 分页 -->
      <pages
        v-if="globalPageParam.total > 0"
        :pageSize="globalPageParam.pageSize"
        :total="globalPageParam.total"
        :currentPage="globalPageParam.pageNo"
        :currentChange="pageCurrentChange"
        :sizeChange="pageSizeChange"
      ></pages>
      <!-- /分页 -->

      <!-- <resume
        :resumeFlag="resumeFlag"
        v-if="resumeFlag.flag"
        :backRoute="resumeBackRoute"
      ></resume> -->
      <resume-list
        :resumeFlag="resumeFlag"
        v-if="resumeFlag.flag"
        :backRoute="resumeBackRoute"
      ></resume-list>
    </div>
  </div>
</template>

<script>
import banners from "../common/banner";
import pages from "../common/pages";
// import resume from "../common/resume";
import resumeList from "../common/resumelist";
import { dictData } from "../request/api";

import { isLogin, getLoginUser } from "../../utils/auth";
import { ListToTree } from "../../utils/tools";
import { MessageBox } from "element-ui";
import { mapMutations, mapState, mapGetters, mapActions } from "vuex";
import BrowserSuggestion from "../common/BrowserSuggestion";

export default {
  components: {
    banners,
    pages,
    resumeList,
    BrowserSuggestion,
  },
  name: "home",
  data() {
    return {
      // 全局返回路由
      globalBackRoute: {},
      SearchForm: {
        gw: "",
        xl: "",
        gzdd: "",
        type: "3",
        isIndex: "false",
        // 公司搜索
        dw: "",
        dwmh: "",
      },
      expandMore: false,
      // 是否显示搜索扩展栏
      showExpandMore: false,
      resumeBackRoute: {
        path: "/internal",
      },
      resumeFlag: {
        flag: false,
      }, //简历弹窗

      jobsList: [],
      dictList: [],
      commoneduList: [],
      orgList: [],
      orgsTree: [],
      orgsTreePrps: {
        label: "name",
        children: "children",
      },

      // 岗位信息
      // SelectData: {
      //   postoid: "",
      //   postname: "",
      //   orgname: "",
      // },
      userInfo: {},
    };
  },
  mounted() {
    // 加载数据字典
    this.dictData("org_post", "dictList");
    this.dictData("org_orgs", "orgList").then((res) => {
      // console.log(data)
      let tree = ListToTree(res, 0);
      // console.log(tree)
      this.orgsTree = tree;
    });
    this.dictData("bd_education", "commoneduList");
    // this.initData()

    // 判断是否要恢复数据
    if (this.globalPageDataRestore) {
      // 消费数据
      this.putGlobalPageDataRestore(false);

      if (this.globalPageParam["requestType"] == "internal-jobsData") {
        // 恢复四个字段
        this.SearchForm["gw"] = this.globalSearchFormData["gw"];
        this.SearchForm["xl"] = this.globalSearchFormData["xl"];
        this.SearchForm["gzdd"] = this.globalSearchFormData["gzdd"];
        this.SearchForm["dw"] = this.globalSearchFormData["dw"];
        this.SearchForm["dwmh"] = this.globalSearchFormData["dwmh"];
      } else {
        // 不是当前页面的数据
        // 正常初始化数据
        this.searchFromAction();
      }
    } else {
      // 正常初始化数据
      this.searchFromAction();
    }
  },
  computed: {
    ...mapState([
      // 全局分页参数
      "globalPageParam",
      "globalPageData",
      "globalPageDataKey",
      "globalSearchFormData",
      // 分页是否恢复
      "globalPageDataRestore",
      // 全局分页参数
    ]),
    ...mapGetters(["getCurrGlobalPageDataKey"]),
    currentPageData() {
      if (!this.globalPageData[this.getCurrGlobalPageDataKey]) {
        return [];
      }
      return this.globalPageData[this.getCurrGlobalPageDataKey].data;
    },
  },
  methods: {
    ...mapMutations([
      // 全局路由生产
      "pushBackRoute",
      // 分页action
      "putGlobalPageParam",
      "resetGlobalPageParam",
      "resetGlobalPageParamWithData",
      "putGlobalPageData",
      "resetGlobalPageData",
      "clearGlobalPageData",
      "setCurrGlobalPageDataKey",
      "resetCurrGlobalPageDataKey",
      "putGlobalSearchFormData",
      // 全局职业选择
      "setResumeSelectData",
      // 全局字典
      "putGlobalPageDataRestore",
    ]),
    ...mapActions([
      // 全局路由消费
      "popBackRoute",
      "globalPageRequest",
      "globalDictDataRequest",
    ]),
    searchFromAction() {
      // 设置参数到全局中
      this.putGlobalSearchFormData(this.SearchForm);
      // 重置分页参数
      this.resetGlobalPageParam();
      // 请求后台搜索
      this.searchFromStore();
    },
    searchFromReset() {
      // 重置搜索表单
      this.$refs.SearchForm.resetFields();

      // 重置公司
      this.SearchForm["dw"] = null;
      this.$refs["corp-tree"].setCurrentKey(null);
    },
    searchFromStore() {
      // 从全局表单获取参数
      this.globalPageRequest({
        type: "internal-jobsData",
        SearchForm: this.SearchForm,
      });
    },
    pageSizeChange(pageSize) {
      // 重置分页参数
      this.resetGlobalPageParam();
      // 设置
      this.putGlobalPageParam({
        pageSize,
      });
      // 搜索
      this.searchFromStore();
    },
    pageCurrentChange(pageNo) {
      this.putGlobalPageParam({
        pageNo,
      });
      //  现在时间
      let nowTime = new Date().getTime();
      // 判断是否从缓存中获取数据
      let cacheData = this.globalPageData[this.getCurrGlobalPageDataKey];
      if (
        cacheData &&
        cacheData.lastTime &&
        nowTime - cacheData.lastTime < 1000 * 60 * 5
      ) {
        // 如果缓存中有数据， 显示缓存中的数据
        this.setCurrGlobalPageDataKey();
        return;
      }
      // 搜索
      this.searchFromStore();
    },
    handleNodeClick(data) {
      this.SearchForm["dw"] = data.oid;
      this.searchFromAction();
    },
    dictData(type, list) {
      let data = {
        type: type,
        flag: 3,
      };
      return dictData(data, true).then((response) => {
        this[list] = response.data;
        return response.data;
      });

      //   return this.globalDictDataRequest({
      //     key: type,
      //     cacheName: list,
      //   }).then((res) => {
      //     this[list] = res;
      //     return res;
      //   });
    },

    // link(oid) {
    //   this.$router.push(`/internalList?oid=${oid}`);
    // },
    // 点击去详情
    setSelectDataToDetail(postoid, postname, orgname) {
      // 使用恢复
      this.putGlobalPageDataRestore(true);

      // // 设置选中数据
      // this.setResumeSelectData({
      //   oid: postoid,
      //   postoid: postoid,
      //   postname: postname,
      //   orgname: orgname,
      // });
      // 设置全局返回路由
      // this.pushBackRoute({
      //   name: "internal",
      // });

      // this.$router.push(
      //   `/internalList?oid=${postoid}&postoid=${postoid}&orgname=${orgname}&postname=${postname}`
      // );
      this.$router.push(
        `/internalList?oid=${postoid}`
      );
    },
    search() {
      // this.Data.pageNo = this.offset;
      // this.Data.pageSize = this.limit;
      // 设置参数查询
      // this.initData()
    },
    applyJob(postoid, postname, orgname, zpxs) {
      if (!isLogin()) {
        this.$router.push("/login");
        return;
      }

      this.userInfo = getLoginUser();
      //判断当前岗位是否是内部招聘
      if (zpxs.indexOf("3") != -1) {
        //如果是内部招聘，需要判断是否已进行身份认证
        if (this.userInfo.hrpsn == "" || this.userInfo.hrpsn <= 0) {
          MessageBox.confirm("当前职位为内部招聘，请先进行身份认证。", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            this.$router.push("/auth");
          });
          return;
        }
      }
      // 设置选中数据
      this.setResumeSelectData({
        oid: postoid,
        postoid: postoid,
        postname: postname,
        orgname: orgname,
      });

      // 设置全局返回路由
      // this.pushBackRoute({
      //   name: "internal",
      // });
      // 判断用户是否登录
      this.resumeFlag.flag = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  .wrapper {
    width: 100%;
    margin: 0 auto;
    padding-left: 24px;
    padding-right: 24px;
    padding-top: 20px;
    padding-bottom: 40px;

    // curr-banner
    .curr-banner {
      display: none;
      margin-bottom: 24px;
    }
    // curr-banner

    // 标题
    .page-title {
      height: 48px;
      line-height: 48px;
      background: #fff;
      // margin-bottom: 12px;
      border-radius: 4px;

      .title {
        font-size: 16px;

        a {
          position: relative;
          margin-left: 12px;
        }

        a::after {
          position: absolute;
          left: -8px;
          top: 0;
          bottom: 0;
          content: "";
          width: 4px;
          background: #0089d0;
        }
      }
    }
    // 标题

    // search-container

    ::v-deep {
      .el-form-item.search-item {
        width: 100%;
        display: flex;
        margin-bottom: 12px;
      }
      .search-form .el-form-item__label {
        flex: 0 0 auto;
        line-height: 28px;
      }
      .search-form .el-form-item__content {
        flex: auto;
        line-height: 28px;
      }
      .search-form .el-select {
        width: 100%;
      }
    }

    .search-container {
      background: #fff;
      padding-top: 24px;
      padding-left: 12px;
      padding-right: 12px;
      padding-bottom: 12px;
      margin-bottom: 12px;
      border-radius: 4px;

      .search-opts {
        text-align: center;
      }

      .el-button.el-button--mini {
        border-radius: 0;
      }
    }

    // search-container

    //search-list
    .search-list {
      display: flex;
      .corp-tree {
        display: none;
        flex: 0 0 auto;
        background: #fff;
        border-radius: 4px;
        margin-bottom: 12px;
        min-width: 256px;

        ::v-deep {
          .el-tree {
            .el-tree-node.is-current {
              & > .el-tree-node__content {
                background: #0089d0;
                color: #fff;
                color: rgba(255, 255, 255, 0.8);
                // background: linear-gradient(to right, #ffa39e, #4bc0eb);
              }
            }

            .el-tree-node {
              & > .el-tree-node__content:hover {
                background: #0089d0;
                color: #fff;
                color: rgba(255, 255, 255, 0.8);
                // background: linear-gradient(to left, #ffa39e, #4bc0eb);
              }
            }
          }

          .el-tree-node__content {
            line-height: 32px;
            height: 32px;
          }
        }
      }

      .right-content {
        flex: auto;
        // margin-left: 12px;
        // 768
      }

      .no-jobs-list {
        text-align: center;
        font-size: 14px;
      }

      .campus {
        .campus-cont {
          position: relative;
          // background: #E6F4F1;
          background: #fff;
          padding: 12px;
          border-radius: 4px;
          margin-bottom: 12px;
          color: rgba(0, 0, 0, 0.8);
          font-size: 14px;
          cursor: pointer;

          .title {
            font-size: 18px;
            font-weight: bold;
            margin-right: 80px;
            color: #0089d0;
            margin-bottom: 12px;
          }

          &:active .title {
            opacity: 0.5;
          }

          .corp {
            display: block;
            line-height: 32px;
          }

          .desc {
            line-height: 32px;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;

            .tip {
              flex: auto;
              margin-right: 12px;
            }

            .date {
              flex: 0 0 auto;
            }
          }

          .foot {
            line-height: 22px;
          }

          .apply-btn {
            // 申请按钮隐藏
            display: none;
            position: absolute;
            right: 12px;
            top: 12px;

            .el-button {
              // border-radius: 0;
              // background: linear-gradient(to right, #ffa39e, #f5222d);
              // border: none;
              // color: rgba(255, 255, 255, 0.8);
              border-radius: 0;
              border: none;
              color: rgba(255, 255, 255, 0.8);
              height: 32px;
              width: 80px;
              padding: 0;
              font-size: 14px;
              &:active {
                opacity: 0.5;
              }
            }
          }
        }
      }
    }

    //search-list
  }
}

@media screen and (min-width: 320px) {
}

@media screen and (min-width: 480px) {
}
/* 移动 */
@media screen and (min-width: 576px) {
}
/* 平板 */
@media screen and (min-width: 768px) {
  .wrap {
    .wrapper {
      width: 100%;
      margin: 0 auto;

      // search-container
      .search-container {
        .search-opts {
          text-align: right;
        }
      }

      // search-container

      //search-list
      .search-list {
        .campus {
          .campus-cont {
            .apply-btn {
              // 申请按钮显示
              display: block;
            }
          }
        }
      }
    }
  }
}

/* PC */
@media screen and (min-width: 992px) {
  .wrap {
    .wrapper {
      // curr-banner
      .curr-banner {
        display: block;
        height: 260px;

        ::v-deep {
          .el-carousel .img-item {
            display: block;
            height: 260px;
            width: 100%;
          }

          .el-carousel .el-carousel__container {
            height: 260px;
          }
        }
      }
      // curr-banner

      //search-list
      .search-list {
        display: flex;
        .corp-tree {
          display: block;
        }

        .right-content {
          margin-left: 12px;
        }

        .campus {
          .campus-cont {
            .corp {
              display: none;
            }

            .apply-btn {
              // 申请按钮隐藏
              display: block;
            }
          }
        }
      }
    }
  }
}
@media screen and (min-width: 1200px) {
  .wrap {
    .wrapper {
      // width: 1200px;

      padding-left: 0;
      padding-right: 0;

      // curr-banner
      .curr-banner {
        height: 320px;

        ::v-deep {
          .el-carousel .img-item {
            display: block;
            height: 320px;
            width: 100%;
          }

          .el-carousel .el-carousel__container {
            height: 320px;
          }
        }
      }
      // curr-banner

      .page-title,
      .search-container,
      .search-list {
        width: 1200px;
        margin-left: auto;
        margin-right: auto;
      }
    }
  }
}
</style>
